import React, {useState} from 'react'
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';


const AddParty = () => {
        const [response, setResponse] = useState();
        const [loading, setLoading] = useState(false);
        const [formData, setFormData] = useState({
            name: '',
            mobile: '',
            email: '',
            drug_license: '',
            drug_image: null,
            pan: '',
            pan_image: null,
            gst: '',
            // gst_type: '',
            // gst_state: '',
            // gst_address: '',
            gst_image: null,
            password: '',
            discount: ''
        });
    
            // Handle form field changes
            const handleChange = (e) => {
                const { id, value, type, files } = e.target;
                
                if (type === "file") {
                    setFormData({
                        ...formData,
                        [id]: files[0],
                    });
                } else {
                    setFormData({
                        ...formData,
                        [id]: value,
                    });
                }
            };
        

    const handleAddParty = async (e) => {
        e.preventDefault();

        if(!formData.gst && !formData.pan){
        setResponse("Fill GST or PAN Details");
        setTimeout(() => {
                setResponse('');
            }, 2000)
            return;
        }
        setLoading(true);
        const formDataToSend = new FormData();
        
        for (const key in formData) {
            if (formData[key] !== null) {
                formDataToSend.append(key, formData[key]);
            }
        }

        try {
            const response = await fetch('https://api.kcmstore.in/dist/add-party', {
                method: 'POST',
                body: formDataToSend,
            });

            setLoading(false);
            if (response.ok) {
                setResponse("Party Added Successfully");
                setTimeout(() => {
                    setResponse('');
                    setFormData({
                        name: '',
                        mobile: '',
                        email: '',
                        drug_license: '',
                        drug_image: null,
                        pan: '',
                        pan_image: null,
                                                gst: '',
                        gst_type: '',
                        gst_state: '',
                        gst_address: '',
                        gst_image: null,
                        password: '',
                        discount: ''    
                    });
                }, 2000)
            }
            else {
                setLoading(false);
                setResponse("Unable to add Party");
                setTimeout(() => {
                    setResponse('');
                }, 2000)
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };


  return (
    <>
                <section className='px-3 py-3'>
                <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>
                    <p className='profile-heading'>Add Party</p>
                    <hr className='profile-hr' />

                    <form className="row g-3 mt-4" onSubmit={handleAddParty}>
                                    <div className="col-md-6">
                                        <label htmlFor="name" className="profile-label">Party Name</label>
                                        <input
                                            type="text"
                                            className="profile-input"
                                            id="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="mobile" className="profile-label">Mobile No</label>
                                        <input
                                            type="tel"
                                            className="profile-input"
                                            id="mobile"
                                            maxLength='10'
                                            value={formData.mobile}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="email" className="profile-label">Email</label>
                                        <input
                                            type="email"
                                            className="profile-input"
                                            id="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label htmlFor="password" className="profile-label">Password</label>
                                        <input
                                            type="password"
                                            className="profile-input"
                                            id="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="drug_license" className="profile-label">Drug License No</label>
                                        <input
                                            type="drug_license"
                                            className="profile-input"
                                            id="drug_license"
                                            value={formData.drug_license}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                            <label htmlFor="drug_image" className="profile-label">Drug License Document</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="drug_image"
                                onChange={handleChange}
                            />
                        </div>

                                    <div className="col-md-6">
                                        <label htmlFor="pan" className="profile-label">Permanent Account No (PAN)</label>
                                        <input
                                            type="pan"
                                            className="profile-input"
                                            id="pan"
                                            value={formData.pan}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                            <label htmlFor="pan_image" className="profile-label">PAN Document</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="pan_image"
                                onChange={handleChange}
                            />
                        </div>

                                    <div className="col-md-6">
                                        <label htmlFor="gst" className="profile-label">Party GSTIN</label>
                                        <input
                                            type="text"
                                            className="profile-input"
                                            id="gst"
                                            value={formData.gst}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* <div className="col-md-6">
                                        <label htmlFor="gst_type" className="profile-label">GSTIN Type</label>
                                        <select
                                            className="profile-input"
                                            id="gst_type"
                                            value={formData.gst_type}
                                            onChange={handleChange}
                                        >
                                            <option value="Registered">Registered</option>
                                            <option value="Not Registered">Not Registered</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="gst_state" className="profile-label">GSTIN State</label>
                                        <input
                                            type="text"
                                            className="profile-input"
                                            id="gst_state"
                                            value={formData.gst_state}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="gst_address" className="profile-label">GSTIN Address</label>
                                        <input
                                            type="text"
                                            className="profile-input"
                                            id="gst_address"
                                            value={formData.gst_address}
                                            onChange={handleChange}
                                        />
                                    </div> */}

                                    <div className="col-md-6">
                            <label htmlFor="gst_image" className="profile-label">GST Document</label>
                            <input
                                type="file"
                                className="profile-input"
                                id="gst_image"
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6">
                        <label htmlFor="discount" className="profile-label">Alloted Discount Percent %</label>
                                        <input
                                            type="text"
                                            className="profile-input"
                                            id="discount"
                                            value={formData.discount}
                                            onChange={handleChange} />
                        </div>


                                    <div className="col-12 text-end">
                                        <button type="submit" className="login-btn">Submit Details</button>
                                    </div>
                                </form>


                    </div>
                    </section>

                    {loading && <Loading setLoading={setLoading} />}
                    {response && <ResponseMsg message={response} />}
    </>
  )
}

export default AddParty
